import React, {useEffect, useState} from 'react';
import {Grid} from "@mui/material";
import PreviousNextButton from "../../../../../components/PreviousNextButton";
import {useIntl} from "react-intl";
import {RequestVisitorDto} from "../../../../../modules/vms/dto/RequestVisitorDto";
import FormFieldText from "../../../../../components/FormFieldText";
import dayjs from "dayjs";
import {Formats} from "../../../../../constants/Formats";

export type VisitRequestConfirmProps = {
    onNext: () => void;
    requestVisitor: RequestVisitorDto;
};
const VisitRequestConfirm: React.FC<VisitRequestConfirmProps> = (props) => {
    const intl = useIntl();

    return (
        <div>
            <Grid container spacing={2} style={{height: '50vh'}}>
                <Grid item xs={6}>
                    <FormFieldText
                        label={intl.formatMessage({id: "VMS_REQUEST_VISITOR_NAME"})}
                        disabled={true}
                        value={props.requestVisitor.fullName}
                    />
                    <FormFieldText
                        label={intl.formatMessage({id: "VMS_REQUEST_VISITOR_MOBILE"})}
                        disabled={true}
                        value={props.requestVisitor.mobile}
                    />
                    <FormFieldText
                        label={intl.formatMessage({id: "VMS_REQUEST_VISITOR_EMAIL"})}
                        disabled={true}
                        value={props.requestVisitor.email}
                    />
                    <FormFieldText
                        label={intl.formatMessage({id: "VMS_REQUEST_VISITOR_COMPANY"})}
                        disabled={true}
                        value={props.requestVisitor.company}
                    />
                </Grid>
                <Grid item xs={6}>
                    <FormFieldText
                        label={intl.formatMessage({id: "VMS_VISIT_REQUEST_HOST_STAFF_NUMBER"})}
                        value={props.requestVisitor.visitRequest?.hostStaffNumber}
                        disabled={true}/>
                    <FormFieldText
                        label={intl.formatMessage({id: "VMS_VISIT_REQUEST_HOST_NAME"})}
                        value={props.requestVisitor.visitRequest?.hostFullName}
                        disabled={true}/>
                    <FormFieldText
                        label={intl.formatMessage({id: "VMS_VISIT_REQUEST_HOST_MOBILE"})}
                        value={props.requestVisitor.visitRequest?.hostMobile}
                        disabled={true}/>
                    <FormFieldText
                        label={intl.formatMessage({id: "VMS_VISIT_REQUEST_HOST_EMAIL"})}
                        value={props.requestVisitor.visitRequest?.hostEmail}
                        disabled={true}/>
                </Grid>
            </Grid>
            <Grid>
                <PreviousNextButton previousDisabled={true} onNext={props.onNext}/>
            </Grid>
        </div>
    );
};

export default VisitRequestConfirm;
